import classNames from 'classnames';

const AddOfferButton = ({icon, disabled, setIsOpen}: IAddOfferButtonProps) => {
  return (
    <>
      <button
        disabled={disabled}
        className={classNames(
          ' text-white text-center w-full rounded-md py-4 bg-primary',
          {'!bg-gray-300': disabled},
        )}
        onClick={() => setIsOpen(true)}
      >
        <span className={`${icon} mx-1`}></span>
        ثبت پیشنهاد
      </button>
    </>
  );
};

export default AddOfferButton;
